// NPM Imports
import React from "react";

// Component Imports
import AddAnotherRule from "./AddAnotherRule";
// import AddAnotherRuleUpgrade from "./AddAnotherRuleUpgrade";
// import { FeatureGating } from "../../../../commonComponents";

// Internal Imports
// import { FEATURES } from "../../../../constants";

// Destructuring
// const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return <AddAnotherRule {...props} />;
}
